import { render, staticRenderFns } from "./NewCvPopup.vue?vue&type=template&id=1264d030&"
import script from "./NewCvPopup.vue?vue&type=script&lang=js&"
export * from "./NewCvPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports